import React from "react";
import { useAuth } from "../../contexts/AuthProvider/AuthProvider";
import { api } from "../../api/api";
import { useDispatchWrapper } from "../../hooks";
import { showMessage } from "../../redux/messages/messagesActions";
import { LoadState } from "../../constants/enums";
import { LinearProgress } from "@mui/material";

interface IAppConfigContext {
  companyName: string;
  logo: string;
  favIcon: string;
  brokerPrivacyOfficer: string;
}

export const AppConfigContext = React.createContext<IAppConfigContext>({
  companyName: "",
  logo: "",
  favIcon: "",
  brokerPrivacyOfficer: "",
});

export const useAppConfig = () => React.useContext(AppConfigContext);

export const AppConfigProvider: React.FC<{ children: React.ReactNode }> = (
  props
) => {
  const [companyName, setCompanyName] = React.useState<string>("");
  const [logo, setLogo] = React.useState<string>("");
  const [favIcon, setFavIcon] = React.useState<string>("");
  const [loading, setLoading] = React.useState<LoadState>(LoadState.NotLoaded);
  const { user } = useAuth();
  const [brokerPrivacyOfficer, setBrokerPrivacyOfficer] = React.useState("");
  const dispatch = useDispatchWrapper();

  const fetchAppConfig = async () => {
    const localConfig = localStorage.getItem("config");

    if (localConfig) {
      const { companyName, logo, favIcon,broker_privacy_officer } = JSON.parse(localConfig);
      console.log("#logo1", logo);
      setCompanyName(companyName);
      setBrokerPrivacyOfficer(broker_privacy_officer)
      setLogo(logo);
      setFavIcon(favIcon);
      setLoading(LoadState.Loaded);
    }
    try {
      setLoading(LoadState.InProgress);
      const response = await api.get(
        "/accounting/get-account-company-information-public"
      );

      const companyData = response.data.data[0];
      
      const configData = {
        companyName: companyData.company_name,
        logo: companyData.preview_logo,
        favIcon: companyData.preview_fav_icon,
        broker_privacy_officer: companyData.broker_privacy_officer,
      };

      setCompanyName(configData.companyName);
      setLogo(configData.logo);
      setFavIcon(configData.favIcon);
      setBrokerPrivacyOfficer(configData.broker_privacy_officer);
      localStorage.setItem("config", JSON.stringify(configData));
      setLoading(LoadState.Loaded);
    } catch (err: any) {
      setLoading(LoadState.Failed);
      dispatch(
        showMessage({
          type: "error",
          message: err?.response?.data?.message,
          displayAs: "snackbar",
        })
      );
    }
  };

  React.useEffect(() => {
    fetchAppConfig();
  }, []);

  // if (!user.isLogin) {
  //   return <>{props.children}</>;
  // }

  if (loading !== LoadState.Loaded) {
    return <LinearProgress />;
  }

  return (
    <AppConfigContext.Provider value={{ companyName, logo, favIcon, brokerPrivacyOfficer }}>
      {props.children}
    </AppConfigContext.Provider>
  );
};
